import IndexedDBPlayerStore from "localstorage/indexedDB/IndexedDBPlayerStore";
import {Assert} from "common/Assert";
import {Event} from "common/Event";

/***********************************************************************
 Watcher for HTML5-IndexedDB changes. In case of data changed, the
 given event will be fired.
 ***********************************************************************/
export function IndexedDBChangeWatcher(){

    const indexedDBPlayerStore = new IndexedDBPlayerStore(),
          dataTimestamps = new Map();

    let timoutId = -1,
        time = 0,
        changeEventId = null;

    function onCallbackInterval() {

        indexedDBPlayerStore.each( (lessonId, dataJson ) => {
            try {
                const data = JSON.parse(dataJson);
                if (isValidEntry(data) && timeStampHasChanged(lessonId, data.timestamp)) {
                    Event.trigger(document, changeEventId);
                    refreshTimeStamp(lessonId, data.timestamp);
                    return "break";
                }
            }
            catch(e){
            }
            return "continue";
        }).then(() => {
            timoutId = window.setTimeout( onCallbackInterval, time );
        });
    }

    function isValidEntry( data ){
        return data && data.timestamp;
    }

    function timeStampHasChanged( id, timeStamp ){

        if( !dataTimestamps.has( id ) ){
            return true;
        }

        const savedTimeStamp = dataTimestamps.get( id );
        return savedTimeStamp !== timeStamp;
    }

    function refreshTimeStamp( id, timeStamp ) {
        dataTimestamps.set(id, timeStamp);
    }

    // revealing public api
    return {

        startTimer: function( checkIntervalTime, eventId ) {

            Assert.checkArgumentType(  checkIntervalTime, "number" );

            if( (timoutId !== -1) || ( checkIntervalTime <= 0) || ( typeof eventId !== "string" ) ) {
                return Promise.resolve(false);
            }


            // mark timer as used
            timoutId = 1;

            return new Promise( (resolve) => {

                indexedDBPlayerStore.init().then( (succeeded) => {

                    if( !succeeded ){
                        timoutId = -1;
                        resolve( false );
                        return;
                    }

                    time =  checkIntervalTime;
                    changeEventId = eventId;
                    timoutId = window.setTimeout( onCallbackInterval, 500 );

                    resolve( true );
                });
            });
        },

        stopTimer: function () {
            clearTimeout( timoutId );
            timoutId = -1;
            time = 0;
            changeEventId = null;
        }
    };
}
